module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-mask-2.46ba8116.png";